<template>
  <!-- TODO: I don't see the black arrows in tablet or medium screens -->
  <div
    v-if="!isScreenSmall"
    class="ds-container"
  >
    <div class="ds-grid gallery-grid-md-lg">
      <div
        class="ds-grid__col ds-grid__col--12"
        :class="{ 'ds-margin-bottom-48': title || description }"
      >
        <div
          v-if="title || description"
          class="ds-display-flex ds-flex-direction-column"
        >
          <h2 class="ds-heading">
            {{ title }}
          </h2>
          <p
            v-if="description"
            class="ds-text ds-margin-top-12"
          >
            {{ description }}
          </p>
        </div>
      </div>
      <div
        v-for="(item, index) in safeArticles"
        :key="`item-${index}`"
        class="ds-grid__col ds-grid__col--4 gallery-col-md-lg"
      >
        <DsCardBlog
          :image="item.image"
          :image-with-sizes="item.imageWithSizes"
          :title="item.title"
          :tag="item.tag"
          :link="item.link"
          :subtitle="`${item.dateFormatted} · ${t('minutesAmount', item.minutesToRead)}`"
          aspect-ratio="16/9"
          show-placeholder-on-image-error
        />
      </div>
      <div class="ds-grid__col ds-grid__col--12">
        <DsLink
          v-if="seeAllLink"
          :url="seeAllLink"
          type="button"
          :content="seeAllLabel"
          nuxt
          variant="secondary"
          color="black"
          class="ds-md-margin-top-48 ds-margin-top-12"
        />
      </div>
    </div>
  </div>
  <div v-else>
    <DsImageGallery
      :screen="screen"
      :items="safeArticles.length"
      :width="{ small: 272, large: 368 }"
      :title="title"
      :description="description"
      type="primary"
    >
      <template #default="{ index }">
        <DsCardBlog
          v-if="safeArticles[index - 1]"
          :tag="safeArticles[index - 1].tag"
          :image="safeArticles[index - 1].image"
          :image-with-sizes="safeArticles[index - 1].imageWithSizes"
          :eyebrow="safeArticles[index - 1].eyebrow"
          :title="safeArticles[index - 1].title"
          :link="safeArticles[index - 1].link"
          :subtitle="`${safeArticles[index - 1].dateFormatted} · ${t('minutesAmount', safeArticles[index - 1].minutesToRead)}`"
          aspect-ratio="16/9"
          show-placeholder-on-image-error
        />
      </template>
      <template #image-gallery-footer>
        <DsLink
          v-if="seeAllLink"
          :url="seeAllLink"
          type="button"
          :content="seeAllLabel"
          nuxt
          variant="secondary"
          color="black"
          class="ds-md-margin-top-48 ds-margin-top-12"
        />
      </template>
    </DsImageGallery>
  </div>
</template>

<script setup>
import { DsImageGallery, DsLink, DsCardBlog } from 'awds'
const { screen, isScreenSmall } = useScreen()
const { t } = useI18n()

/**
 * Knowledge Hub Articles Gallery Component
 *
 * @example
 * ```js
 * import KnowledgeHubArticlesGallery from '@/components/knowledge-hub/knowledge-hub-articles-gallery.vue'
 *
 * export default {
 *   components: { KnowledgeHubArticlesGallery },
 *   template: `<div>
 *     <KnowledgeHubArticlesGallery
 *        :title="aTitle"
 *        :articles="articles"
 *        :see-all-label="aLabel"
 *        :see-all-link="aURL"
 *      />
 *     />
 *   </div>`
 * }
 * ```
 */

const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  description: {
    type: String,
    default: ''
  },
  articles: {
    type: Array,
    default: () => []
  },
  seeAllLabel: {
    type: String,
    default: ''
  },
  seeAllLink: {
    type: String,
    default: ''
  }
})

const safeArticles = computed(() => {
  return props.articles.filter((a) => a && a.image)
})
</script>
